<div class="popup">
  <p class="title">{{ !isCRCampaign ? 'Détail de la demande' : 'Détail du désideratas' }}</p>

  @if (
    isNurseProfile &&
    effectif &&
    effectif.length > 0 &&
    !isCRCampaign &&
    (accessOption?.pageUrl?.includes('/hrsuite/liste') || accessOption?.displaySearchBar)
  ) {
    <div class="day-info">
      @if (!isEffectifGarde && !isFormationsAndParamedicRulesLoading) {
        <app-effective-needs
          [isFetching]="isEffectiveNeedsLoading"
          [formations]="formations"
          [paramedicRules]="paramedicRules"
          [effective]="originalEffective[0]"
          [needs]="originalNeeds[0] && originalNeeds[0].roomsNeeds"
          [layout]="'row'"
          [showDifference]="true"
          [showStatusIcon]="false"
          [separateMorningAfternoon]="false"
          [hospitals]="[cr.hospital._id]"
        >
        </app-effective-needs>
      }
      @if (isEffectifGarde) {
        <div class="day-info">
          {{ effectif[0].nurseEffectifDay }} personne(s) {{ isNurseProfile ? "d'astreinte" : 'de garde' }}
        </div>
      }
    </div>
  } @else if (isNurseProfile && !isCRCampaign && showEffectiveNeedsByReasonsMaps && needsEffectifs?.[0]) {
    <div>
      {{ (needsEffectifs?.[0]?.effectifs ?? 0) + ' / ' + (needsEffectifs?.[0]?.needs ?? 0) }}
      <span
        [ngClass]="{
          'green-text': (needsEffectifs?.[0]?.difference ?? 0) >= 0,
          'red-text': (needsEffectifs?.[0]?.difference ?? 0) < 0,
          diff: true,
        }"
      >
        (
        <span class="bold"
          >{{ ((needsEffectifs?.[0]?.difference ?? 0) >= 0 ? '+' : '') + (needsEffectifs?.[0]?.difference ?? 0) }}
        </span>
        )
      </span>
    </div>
  }

  <div *ngIf="isAnesthesiste && needsEffectifs && needsEffectifs[0] && !isCRCampaign" class="day-info">
    <div *ngIf="!isEffectifGarde">
      {{ needsEffectifs[0].effectifs + ' / ' + needsEffectifs[0].needs }}
      <span
        [ngClass]="{
          'green-text': needsEffectifs[0].difference >= 0,
          'red-text': needsEffectifs[0].difference < 0,
          diff: true,
        }"
      >
        (
        <span class="bold">{{ (needsEffectifs[0].difference >= 0 ? '+' : '') + needsEffectifs[0].difference }} </span>
        )
      </span>
    </div>

    <div *ngIf="isIade && needsEffectifs && needsEffectifs[0] && !isCRCampaign" class="day-info">
      <div *ngIf="!isEffectifGarde">
        {{ needsEffectifs[0].effectifs + ' / ' + needsEffectifs[0].needs }}
        <span
          [ngClass]="{
            'green-text': needsEffectifs[0].difference >= 0,
            'red-text': needsEffectifs[0].difference < 0,
            diff: true,
          }"
        >
          (
          <span class="bold"> {{ (needsEffectifs[0].difference >= 0 ? '+' : '') + needsEffectifs[0].difference }}</span>
          )
        </span>
      </div>

      <div *ngIf="isEffectifGarde && !isCRCampaign" class="day-info">
        {{ needsEffectifs[0].effectifs }} personne(s) {{ isNurseProfile ? "d'astreinte" : 'de garde' }}
      </div>
    </div>
  </div>

  <div class="details">
    <div class="detail" *ngIf="!isCRCampaign">
      <div class="name">
        <p>Date de début :</p>
      </div>
      <div fxFlex class="value">
        <p>{{ formatedFromDate }}</p>
      </div>
    </div>
    <div class="detail" *ngIf="!isCRCampaign">
      <div class="name">
        <p>Date de fin :</p>
      </div>
      <div class="value">
        <p>{{ formatedToDate }}</p>
      </div>
    </div>
    <div class="detail" *ngIf="isCRCampaign">
      <div class="name">
        <p>Date :</p>
      </div>
      <div class="value">
        <p>{{ formatedToDate }}</p>
      </div>
    </div>
    <div class="detail">
      <div class="name">
        <p>Type :</p>
      </div>

      <div class="value" *ngIf="!isCRCampaign">
        <p>{{ cr.reason.availability == 'AVAILABLE' ? 'Présence' : 'Absence' }}</p>
      </div>
      <div class="value" *ngIf="isCRCampaign">
        <p>{{ cr.availability == 'AVAILABLE' ? 'Oui' : 'Non' }}</p>
      </div>
    </div>
    <div class="detail" *ngIf="isCRCampaign">
      <div class="name">
        <p>Campagne :</p>
      </div>
      <div class="value">
        <p>{{ cr.campaignName }}</p>
      </div>
    </div>
    <div class="detail" *ngIf="isCRCampaign && cr.reasonMaps && cr.reasonMaps.length > 0">
      <div class="name">
        <p>Codes horaire :</p>
      </div>
      <div class="value">
        <p *ngFor="let reasonMap of cr.reasonMaps">
          {{
            (reasonMap.code === 'SMARTOP_DAY_ASTREINTE' || reasonMap.code === 'SMARTOP_NIGHT_ASTREINTE'
              ? 'Astreinte'
              : reasonMap.code) +
              ' (' +
              (cr.period === 'NIGHT'
                ? reasonMap.nightStartTime.toString().substring(11, 16)
                : reasonMap.morningStartTime.toString().substring(11, 16)) +
              ' - ' +
              (cr.period === 'NIGHT'
                ? reasonMap.nightEndTime.toString().substring(11, 16)
                : reasonMap.afternoonEndTime.toString().substring(11, 16)) +
              ')'
          }}
        </p>
      </div>
    </div>
    <div
      class="detail"
      *ngIf="
        (!isCRCampaign &&
          (!cr.isExtraclinique ||
            cr.isExtraclinique ||
            (isMultiHospital && !cr.isExtraclinique && cr.reason.availability == 'AVAILABLE'))) ||
        (isCRCampaign && isMultiHospital && cr.availability == 'AVAILABLE')
      "
    >
      <div class="name">
        <p>Détail :</p>
      </div>
      <div class="value" *ngIf="!isCRCampaign">
        <p *ngIf="!cr.isExtraclinique">{{ cr.reason.title | translate: hospitalNames : isNurse }}</p>
        <p *ngIf="cr.isExtraclinique">{{ hospitalNames.extracliniqueName }}</p>
        <p *ngIf="isMultiHospital && !cr.isExtraclinique && cr.reason.availability == 'AVAILABLE'">
          <!-- - {{ cr.hospital.name }} -->
          - {{ cr.hospital.displayName }}
        </p>
      </div>
      <div class="value" *ngIf="isCRCampaign">
        <p *ngIf="isMultiHospital && cr.availability == 'AVAILABLE'">
          <!-- - {{ cr.hospital.name }} -->
          - {{ cr.hospital.displayName }}
        </p>
      </div>
    </div>
    <div class="detail" *ngIf="!isCRCampaign">
      <div class="name">
        <p>Message :</p>
      </div>
      <div class="value">
        <p>{{ cr.requestDescription ? cr.requestDescription : 'Aucun message' }}</p>
      </div>
    </div>
    <div
      class="detail"
      *ngIf="!isCRCampaign && (accessOption?.pageUrl?.includes('/hrsuite/liste') || accessOption?.displaySearchBar)"
    >
      <div class="name">
        <p>Nbr. demande :<br />sur période</p>
      </div>
      <div class="value">
        <p>{{ requestsCounter }}</p>
      </div>
    </div>
  </div>
</div>
